import apiServices from '@/shared/services/api/axios'
import {
    IPayloadCreateInquiryAdvisor,
    ITypeParamsDetailInquiryAdvisor,
    IPayloadDeleteInquiryAdvisor,
    ITypePayloadAnswerInquiryAdvisor
} from '@/modules/advisor/modules/inquiry/shared/@types'

const InquiryProviderService = {
    apiGetInquiryProvider(payload: any) {
        let url = '/provider/inquiries'

        if (payload) {
            let index = 0
            for (const key in payload) {
                if (payload[key]) {
                    if (!index) {
                        url += `?${key}=${payload[key]}`
                    }
                    if (index) {
                        url += `&${key}=${payload[key]}`
                    }
                    index++
                }
            }
        }
        return apiServices.get(url)
    },
    apiGetInquiryDetailAdvisor(params: ITypeParamsDetailInquiryAdvisor) {
        return apiServices.get('/provider/inquiry-detail', { params })
    },
    apiCreateInquiryProvider(payload: IPayloadCreateInquiryAdvisor) {
        return apiServices.post('/provider/create-inquiry', payload)
    },
    apiDeleteInquiryAdvisor(payload: IPayloadDeleteInquiryAdvisor) {
        return apiServices.post('/provider/delete-inquiry', payload)
    },
    apiCreateInquiryAnswerAdvisor(payload: ITypePayloadAnswerInquiryAdvisor) {
        return apiServices.post('/provider/create-anwser-inquiry', payload)
    },
    apiUpdateStatusReadInquiryProvider(id: number) {
        return apiServices.post(`/provider/inquiries/read/${id}`)
    }
}
export default InquiryProviderService
